"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromoModal = require("./components/PromoModal");
Object.keys(_PromoModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromoModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromoModal[key];
    }
  });
});
var _PurchaseTermsModal = require("./components/PurchaseTermsModal");
Object.keys(_PurchaseTermsModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PurchaseTermsModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PurchaseTermsModal[key];
    }
  });
});
var _FullPriceModal = require("./components/FullPriceModal");
Object.keys(_FullPriceModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FullPriceModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FullPriceModal[key];
    }
  });
});